import axios from 'axios'
import ErrorHandlingInterceptor from '@/api/interceptors/errorHandler'

export const passThroughAxios = axios.create({
  baseURL: '/api/cst/',
})

ErrorHandlingInterceptor.errorHandlingInterceptor(passThroughAxios)
